import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Code } from 'gatsby-theme-docz/src/components/Code';
import { Column } from 'simple-flexbox';
import CollapsibleContent from 'react-collapsible-content';
import ToggleButtonComponent from './common/ToggleButtonComponent';
import TextComponent from './common/TextComponent';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "basic-example"
    }}>{`Basic Example`}</h1>
    <p>{`In these examples we are using `}<a parentName="p" {...{
        "href": "#togglebuttoncomponent"
      }}>{`ToggleButtonComponent`}</a>{` and `}<a parentName="p" {...{
        "href": "#textcomponent"
      }}>{`TextComponent`}</a>{` (see code below), but you can use your own components.`}</p>
    <p>{`We are also using `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/simple-flexbox"
      }}>{`simple-flexbox`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/aphrodite"
      }}>{`aphrodite`}</a>{` to make these UI Components.`}</p>
    {
      /* prettier-ignore-file */
    }
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'() => {\n  const [expanded, setExpanded] = React.useState(false)\n  const styles = {\n    container: { maxWidth: 800, width: \'100%\' },\n  }\n  return (\n    <Column style={styles.container}>\n      <ToggleButtonComponent\n        expanded={expanded}\n        onClick={() => setExpanded(prev => !prev)}\n      />\n      <CollapsibleContent expanded={expanded}>\n        <TextComponent />\n      </CollapsibleContent>\n    </Column>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Code,
      Column,
      CollapsibleContent,
      ToggleButtonComponent,
      TextComponent,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    {() => {
        const [expanded, setExpanded] = React.useState(false);
        const styles = {
          container: {
            maxWidth: 800,
            width: '100%'
          }
        };
        return <Column style={styles.container} mdxType="Column">
                <ToggleButtonComponent expanded={expanded} onClick={() => setExpanded(prev => !prev)} mdxType="ToggleButtonComponent" />
                <CollapsibleContent expanded={expanded} mdxType="CollapsibleContent">
                    <TextComponent mdxType="TextComponent" />
                </CollapsibleContent>
            </Column>;
      }}
    </Playground>
    <h2 {...{
      "id": "togglebuttoncomponent"
    }}>{`ToggleButtonComponent`}</h2>
    <Code className={'tsx'} mdxType="Code">
    {`
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Row } from 'simple-flexbox';
const styles = StyleSheet.create({
    button: {
        border: '1px solid #2EBFA5',
        borderRadius: 4,
        cursor: 'pointer',
        backgroundColor: '#f7f7f7',
        transition: 'border-radius .725s ease-in-out'
    },
    buttonExpanded: {
        borderBottom: 'none',
        borderRadius: '4px 4px 0px 0px',
        transition: 'border-radius .1s ease-in-out'
    },
    arrow: {
        display: 'inline-block',
        borderTop: '5px solid transparent',
        borderBottom: '5px solid transparent',
        borderLeft: '5px solid currentColor',
        verticalAlign: 'middle',
        marginRight: '.7rem',
        transform: 'translateY(-2px)',
        transition: 'transform .425s ease-in-out'
    },
    arrowExpanded: {
        transform: 'rotate(90deg) translateX(-1px)'
    },
    arrowContainer: {
        display: 'block',
        margin: 10,
        marginLeft: 20
    },
    label: {
        margin: 10
    }
});
function ToggleButtonComponent({ title = 'TOGGLE', expanded, onClick, style }) {
    return (
        <Row
            wrap={false}
            className={css(styles.button, expanded && styles.buttonExpanded)}
            onClick={onClick}
            style={style}
        >
            <div className={css(styles.arrowContainer)}>
                <span
                    className={css(
                        styles.arrow,
                        expanded && styles.arrowExpanded
                    )}
                >
                    {' '}
                </span>
            </div>
            <span className={css(styles.label)}>{title}</span>
        </Row>
    );
}
export default ToggleButtonComponent;
 `}
    </Code>
    <h2 {...{
      "id": "textcomponent"
    }}>{`TextComponent`}</h2>
    <Code className={'tsx'} mdxType="Code">
    {`
import React from 'react';
export default function TextComponent({ limit }) {
    const text = 'place a long text here'.substring(0, limit);
    return (
        <p
            style={{
                backgroundColor: '#2EBFA5',
                borderRadius: '0px 0px 4px 4px',
                color: '#2D3747',
                margin: 0,
                padding: 8
            }}
        >
            {text}
        </p>
    );
}
`}
    </Code>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      